import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { DateService } from 'app/date/date.service';
import { UtilService } from 'app/hrms/shared/util.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'app/users/shared/user.service';
import { IOption } from 'ng-select';
import * as firebase from "firebase/app";

@Component({
  selector: 'app-attendance-tab-team',
  templateUrl: './attendance-tab-team.component.html',
  styleUrls: ['./attendance-tab-team.component.scss']
})
export class AttendanceTabTeamComponent implements OnInit {

  date:Date;
  gridView:GridDataResult;
  public skip1 = 0;
  public pageSize = 10;
  public skip2 = 0;
  attendanceList:any;
  attendanceListSearch:any;
  searchForm:FormGroup;
  attendanceForm:FormGroup;
  @Input("employeesOptions") employeesOptions:Array<IOption>;
  @Input("holidays") holidays;
  @Input("change") change;
  toEditDataItem:any;
  @ViewChild("AttendanceModal") AttendanceModal;
  employeeLeaveList:any;
  constructor(private hrmsService:HRMSService, private dateService:DateService, private util:UtilService, private userService: UserService) { }

  ngOnInit() {
    this.initializeForm();
    this.getAllEmployeesLeaves();
    setTimeout(() => {
      this.getSelectedAttendanceList();
    }, 300); 
  }
  initializeForm()
  {
    this.searchForm = new FormGroup({
      name: new FormControl('1000',Validators.required),
      from: new FormControl('',Validators.required),
      to: new FormControl('',Validators.required)
    });
    //this.searchForm.reset();
    this.attendanceForm = new FormGroup({
      date: new FormControl('',Validators.required),
      clockIn: new FormControl({hour: 0, minute: 0, second: 0},Validators.required),
      clockOut: new FormControl({hour: 0, minute: 0, second: 0},Validators.required)
    });
  }
  loadItem()
  {
      this.util.sortList(this.attendanceList);
      //console.log("attendanceList ",this.attendanceList);
      this.gridView = {
        data: this.attendanceList.slice(this.skip1, this.skip1 + this.pageSize),
        total: this.attendanceList.length
      };
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip1 = event.skip;
    this.loadItem();
  }
  onEdit(dataItem)
  {
    this.toEditDataItem = dataItem;
    this.attendanceForm.get("date").setValue(new Date(dataItem.dateId));
    //console.log("dataItem.InTime",dataItem.InTime,dataItem.OutTime);
    //if(dataItem.InTime != "--")
    this.attendanceForm.get("clockIn").setValue(this.util.getTimeIn24HoursFormat(dataItem.InTime));
    //if(dataItem.OutTime != "--")
    this.attendanceForm.get("clockOut").setValue(this.util.getTimeIn24HoursFormat(dataItem.OutTime));
    this.AttendanceModal.show();
  }
clearSearch()
{
  this.searchForm.get("name").setValue("1000");
  this.searchForm.get("from").setValue("");
  this.searchForm.get("to").setValue("");
  this.loadItem();
  this.getSelectedAttendanceList();
}
checkDateExists(date1,date2) {
  let promise = new Promise((resolve, reject) => {
    return this.hrmsService.findDate(date1,date2).once("value").then(res => { // Success
     resolve([res.node_.children_.root_.key,res.val()]);
     });
   });
   return promise;
}
update()
  {
    if(this.attendanceForm.valid && this.attendanceForm.value.clockIn.hour && this.attendanceForm.value.clockOut.hour)
    {
      var clockIn = {
        clockIn: this.util.getFormattedDate(this.attendanceForm.value.clockIn),
        updatedAt: this.dateService.getTimeandDate().timeStamp
      }
      var clockOut = {
        clockOut: this.util.getFormattedDate(this.attendanceForm.value.clockOut),
        updatedAt: this.dateService.getTimeandDate().timeStamp
      }
      var key  = firebase.database().ref("attendance/data").push().key;
      this.hrmsService.getFirstClockInOut(this.toEditDataItem.uid,this.toEditDataItem.dateId).once("value").then((data)=>{
        data.forEach((element)=>{
          if(element.numChildren()>0)
          {
            this.hrmsService.updateAttendance(this.toEditDataItem.uid,this.toEditDataItem.dateId,element.key,clockIn).then(()=>{
              this.hrmsService.changeAttendanceStatus(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending").then(()=>{
                this.hrmsService.sendAttendanceNotif(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending","unread");
                this.getSelectedAttendanceList();
              });
            });
          }
          else
          {
            
            this.hrmsService.addAttendance(this.toEditDataItem.uid,this.toEditDataItem.dateId,clockIn,key).then(()=>{
              this.hrmsService.sendAttendanceNotif(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending","unread");
            });
          }
        });
      });
      this.hrmsService.getLastClockInOut(this.toEditDataItem.uid,this.toEditDataItem.dateId).once("value").then((data)=>{
        data.forEach((element)=>{
          if(element.numChildren()>0)
          {
            this.hrmsService.updateAttendance(this.toEditDataItem.uid,this.toEditDataItem.dateId,element.key,clockOut).then(()=>{
              this.hrmsService.changeAttendanceStatus(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending").then(()=>{
                this.hrmsService.sendAttendanceNotif(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending","unread");
                this.getSelectedAttendanceList();
              });
            });
          }
          else
          {
            this.hrmsService.addAttendance(this.toEditDataItem.uid,this.toEditDataItem.dateId,clockOut,key).then(()=>{
              this.hrmsService.sendAttendanceNotif(this.toEditDataItem.uid,this.toEditDataItem.dateId,"pending","unread");
            });
          }
        });
      });
      this.AttendanceModal.hide();
    }
  }
  getAllEmployeesLeaves()
  {
    this.employeeLeaveList = [];
    this.userService.getAllUser().snapshotChanges().subscribe((data)=>{
      data.forEach((user)=>{
        if(user.payload.child("role").val() != 'customer')
        {
            this.hrmsService.getEmployeeLeavesById(user.key).once("value").then((leaves)=>{
              this.employeeLeaveList[user.payload.child("employeeId").val()] = leaves.val();
            });
        }
      });
      });
  }
  public onSubmitSearch()
  {
    //console.log("this.searchForm.value.name",this.searchForm.value.name);
    if(this.searchForm.value.name != null)
    {
      this.getSelectedAttendanceList();
    }
  }
  constructObject(employeeName,date,list,hours)
  {
    var leaveExists = false;
    if(this.employeeLeaveList)
    {
    var userLeaves = this.employeeLeaveList[this.searchForm.value.name];
    for(let i in userLeaves)
    {
      if(this.util.checkDatesWithinRange(userLeaves[i].from,userLeaves[i].to,this.dateService.getDate(new Date(date.key))) && !leaveExists)
      {
        leaveExists = true;
      }
    }
    }
    var object = {
      "Name": employeeName,
      "Date": this.dateService.getFullDate(date.key),
      "InTime": list[0].clockIn?list[0].clockIn:"--",
      "OutTime": list[list.length-1].clockOut?list[list.length-1].clockOut:"--",
      "TotalHours": this.util.msToTime(Number(hours)),
      "uid": this.searchForm.value.name,
      "dateId": date.key,
      "attendanceId": list[list.length-1]?list[list.length-1].key:null,
      "day":this.dateService.dayNameOfWeek(date.key),
      "holidayName":this.holidays[this.dateService.getDate(new Date(date.key))]?this.holidays[this.dateService.getDate(new Date(date.key))].occasion:"",
      "isOnLeave":leaveExists,
      "Status": date.payload.child("status").val()
    };
  this.attendanceList.push(object);
  this.loadItem();
  }
  getSelectedAttendanceList()
  {
    if(this.searchForm.value.name != null)
    {
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 1);
      //console.log("from to ",this.searchForm.value.from,this.searchForm.value.to);
      var date1 = this.searchForm.value.from?(new Date(new Date(this.searchForm.value.from).getDate()-1)):firstDay;
      var date2 = this.searchForm.value.to?new Date(this.searchForm.value.to):lastDay;
      this.hrmsService.getAttendance(this.searchForm.value.name,new Date(date1).getTime(),new Date(date2).getTime()).snapshotChanges().subscribe((data)=>{
        this.attendanceList = [];
        //console.log("snapshotChanges ");
        data.forEach(date=>{
            var list = [];
            var attendanceData = date.payload.child("logs").val();
            var hours= 0;
            for(let i in attendanceData)
            {
                if(attendanceData[i].clockOut!= null)
                {
                  var date1 = new Date(date.key+" "+attendanceData[i].clockIn);
                  var date2 = new Date(date.key+" "+attendanceData[i].clockOut);
                  hours = hours + this.util.getDiff(date1,date2);
                  attendanceData[i].key = i;
                }
                list.push(attendanceData[i]);
            }
            this.userService.getEmployeeDetails(Number(this.searchForm.value.name)).once("value").then((userDetails)=>{
              userDetails.forEach(employee=>{
            this.constructObject(employee.child("name").val(),date,list,hours);
          });
        });
      });
      });
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['change']) {
      if(this.searchForm != null)
      {
        this.getSelectedAttendanceList();
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/attendance/attendance-tab-team/attendance-tab-team.component.ts